import { useGlobalHubSpotMeeting } from "@/contexts/HubSpotMeetingContext";

export const useHubSpotMeetingModal = () => {
  const { isHubSpotMeetingOpen, openHubSpotMeeting, closeHubSpotMeeting } = useGlobalHubSpotMeeting();

  return {
    isHubSpotMeetingOpen,
    openHubSpotMeeting,
    closeHubSpotMeeting,
  };
};
